import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { features, PRICE } from '../data/content';
export function ProductReveal() {
  return <section className="bg-carbon border-b border-carbon-800 py-20 sm:py-24" id="producto" data-id="element-100" data-mp="3610b15902hdj">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)]" data-id="element-101" data-mp="31403sr0ez8ku">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-sm" data-id="element-102" data-mp="2ddw3otmfpqyl">
          <div className="overflow-hidden rounded-lg border border-carbon-700 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.95)]" data-id="element-103" data-mp="2ibp6dcoj42u4">
            <img src="https://cdn.magicpatterns.com/uploads/q5W6RzGhSKT3ZTRgGEHiFW/Screenshot_2026-08-01_at_7.22.43_PM.png" alt="Portada del eBook La Biblia de las Fallas Típicas" className="h-full w-full object-cover" data-id="element-104" data-mp="1uks3epepofv0" />
          </div>
          <div className="absolute -inset-6 -z-10 rounded-3xl bg-volt/10 blur-3xl" aria-hidden="true" data-id="element-105" data-mp="1f0pyxgkjwjha" />
        </motion.div>

        <div data-id="element-106" data-mp="1oslw8petc5kg">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-safety" data-id="element-107" data-mp="1orawr1sehjz5">La solución</p>
          <h2 className="mt-4 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-108" data-mp="s3emeenk3kwd">
            Un manual de diagnóstico, no un libro de teoría.
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-400" data-id="element-109" data-mp="112i5vjqmy2be">
            Cada capítulo parte del síntoma que ves en el mesón y te lleva directo al componente
            que falla, con las mediciones exactas que debes hacer. Edición pensada para el
            especialista en audio y video.
          </p>

          <ul className="mt-8 space-y-4" data-id="element-110" data-mp="2hfqa7jvvvu8d">
            {features.map(feature => <li key={feature} className="flex gap-3" data-id="element-111" data-mp="1rrul2b2pcn0t">
                <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border border-volt/40 bg-volt/10 text-volt" data-id="element-112" data-mp="1mtsyvh9zc7l4">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-113" data-mp="21pqu8xc2x7wa" />
                </span>
                <span className="text-sm leading-relaxed text-slate-300" data-id="element-114" data-mp="1wta4xzt58nhm">{feature}</span>
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-115" data-mp="1901pc8w90npe">
            <CtaButton label={`Obtener mi copia por ${PRICE}`} data-id="element-116" data-mp="143tdb4dclamg" />
          </div>
        </div>
      </div>
    </section>;
}